@import '~style-sheet-helpers/core.less';

.loading-wrapper {
  height: 100%;
  display: flex;
}

.loading-indicator {
  width: 64px;
  height: 64px;
  margin: auto;
}
